import ProgramForm from '@apps/crm/admin/components/programform'
import ImportToken from '@apps/maha/admin/tokens/import'
import StatusToken from '@admin/tokens/status'
import Page from '@admin/components/page'
import New from './new'
import React from 'react'

const mapPropsToPage = (props, context) => ({
  title: 't(Imports)',
  access: { rights: { $oneOf: ['crm:view_contacts','crm:manage_contacts'] } },
  collection: {
    endpoint: '/api/admin/crm/imports',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Import)', key: 'created_at', primary: true, format: ImportToken },
      { label: 't(New)', key: 'created_count', collapsing: true, align: 'right' },
      { label: 't(Merged)', key: 'merged_count', collapsing: true, align: 'right' },
      { label: 't(Verified)', key: 'percent_verified', collapsing: true, align: 'right', format: 'rate' },
      { label: 't(Status)', key: 'status', collapsing: true, format: StatusToken }
    ],
    empty: {
      title: 't(No Contact Imports)',
      text: 't(You have not yet imported any contacts)',
      svg: 'hard_drive_upload',
      buttons: [
        { 
          label: 't(Import Contacts)',
          modal: <ProgramForm form={ New } />
        }
      ]
    },
    entity: 'import',
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/admin/crm/imports/${record.id}`)
  },
  task: {
    svg: 'plus',
    tooltip: 't(Import Contacts)',
    modal: <ProgramForm form={ New } />
  }
})

export default Page(null, mapPropsToPage)
